import { render, staticRenderFns } from "./SearchNew.vue?vue&type=template&id=36ac613e&scoped=true&lang=pug&"
import script from "./SearchNew.vue?vue&type=script&lang=js&"
export * from "./SearchNew.vue?vue&type=script&lang=js&"
import style0 from "./SearchNew.vue?vue&type=style&index=0&id=36ac613e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ac613e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VTextField})
